<button *ngIf="visible" type="button" class="btn btn-secondary" (click)="onBtnClick($event)">{{'ui.close'|translate}}</button>
